<ng-template>
  <div (click)="closed.emit()" class="entity-select">
    <div
      *ngFor="let entity of entities"
    >
      <app-entity-item
        [entity]="entity"
        [primaryEntity]="primaryEntity"
        [entitySelectorsMap]="entitySelectorsMap"
        [isSelected]="isSelected"
        [descriptorControl]="descriptorControl"
        [renderIcon]="renderIcon"
      ></app-entity-item>
    </div>

  </div>
</ng-template>
